import { useEffect, useLayoutEffect } from "react";
import { env as s } from "../utils/env.js";
let n = (e, t) => {
  s.isServer ? useEffect(e, t) : useLayoutEffect(e, t);
};
export {
  n as useIsoMorphicEffect
};
